import { api } from './api';

export interface DashboardData {
  totalAssets: number;
  activeAssets: number;
  inactiveAssets: number;
  assetsInMaintenance: number;
  retiredAssets: number;
  totalAssetAcquisitionCost: number;
  totalAssetMaintenanceCost: number;
  assetPerformance: {
    activePercentage: number;
    downtimePercentage: number;
  };
  distributionChartData: Array<{
    label: string;
    value: number;
    color: string;
  }>;
}

export interface AssetLocation {
  _id: string;
  name: string;
  slug: string;
  type: string;
  address: string;
  contactPerson: string;
  phone: string;
  email: string;
  longitude: string;
  latitude: string;
  owner: string;
  createdAt: string;
  updatedAt: string;
}

export interface AssetLocationResponse {
  result: AssetLocation[];
  totalCount: number;
  currentPage: number;
  totalPages: number;
  previousPage: number | null;
  nextPage: number | null;
}

export interface DashboardApiResponse {
  message: string;
  data: DashboardData;
  error: boolean;
}

export interface LocationApiResponse {
  message: string;
  data: AssetLocationResponse;
  error: boolean;
}

class DashboardService {
  async getDashboardData(): Promise<DashboardData> {
    const response = await api.get('/dashboard');
    return response.data.data;
  }

  async getAssetLocations(): Promise<AssetLocationResponse> {
    const response = await api.get('/asset-location');
    return response.data.data;
  }
}

const dashboardService = new DashboardService();
export default dashboardService;